import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
const CALENDAR_URL = 'https://calendar.app.google/gDsqAVqmwUYmaZHe9';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/ogJMkN5dd1hJJJtdpvFFQv/IMG_6635.jpg';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const bullets = ['Si recibes llamadas de personas que quieren consulta gratis pero no pueden pagar el retainer', 'Si tus competidores aparecen primero en Google aunque no sean mejores que tú', 'Si dependes de referidos para crecer y no tienes un sistema predecible de clientes nuevos cada mes', 'Si tienes presencia en redes sociales pero no genera casos reales', 'Si eres experto en Inmigración, Accidentes, Familia o Criminal pero el mercado no lo sabe'];
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="min-h-screen flex items-center justify-center pt-24 pb-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-168">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/64FgHtFvogGiB1ixs2rmGq/heylloyd-image-1773374013426.png")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-169" />
      <div className="absolute inset-0 z-0 bg-carbon/90 backdrop-blur-[2px]" data-id="element-170" />

      {/* Subtle background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[120px] pointer-events-none z-0" data-id="element-171" />

      <div className="max-w-4xl mx-auto relative z-10 w-full" data-id="element-172">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col items-center text-center" data-id="element-173">
          <motion.div variants={itemVariants} className="mb-8" data-id="element-174">
            <img src={LOGO_URL} alt="Doctor Ecommerce" className="h-14 sm:h-16 w-auto object-contain mx-auto" data-id="element-175" />
          </motion.div>

          <motion.h1 variants={itemVariants} className="font-heading text-3xl sm:text-5xl lg:text-6xl font-bold text-gold leading-tight mb-6" data-id="element-176">
            ¿Pasando horas en consultas gratuitas con personas que no pueden
            pagar tus honorarios?
          </motion.h1>

          <motion.p variants={itemVariants} className="font-body text-base sm:text-xl text-gray-300 max-w-3xl mb-10 sm:mb-12 leading-relaxed" data-id="element-177">
            Implementamos un sistema de captación que filtra y pre-califica a
            los prospectos antes de que lleguen a tu agenda. Solo hablas con
            clientes que ya confían en tu firma y tienen el presupuesto para
            contratar tus servicios.
          </motion.p>

          <motion.div variants={itemVariants} className="w-full max-w-2xl text-left mb-10 sm:mb-12 bg-[#111]/80 backdrop-blur-sm border border-white/10 rounded-2xl p-5 sm:p-8 shadow-2xl" data-id="element-178">
            <ul className="space-y-4" data-id="element-179">
              {bullets.map((bullet, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-3" data-id="element-180">
                  <AlertCircleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-gold shrink-0 mt-0.5" aria-hidden="true" data-id="element-181" />
                  <span className="font-body text-gray-200 text-sm sm:text-lg leading-snug" data-id="element-182">
                    {bullet}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col items-center w-full" data-id="element-183">
            <button onClick={scrollToContact} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg sm:text-xl font-bold text-carbon bg-gold hover:bg-gold-light transition-colors duration-300 rounded-lg shadow-[0_0_20px_rgba(242,183,5,0.3)] hover:shadow-[0_0_30px_rgba(242,183,5,0.5)] focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-carbon" data-id="element-184">
              QUIERO CASOS CALIFICADOS
            </button>

            <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="mt-6 font-body text-sm sm:text-base text-gray-400 hover:text-gold transition-colors underline underline-offset-4" data-id="element-185">
              O agenda directamente tu diagnóstico en 15 minutos →
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}